(function () {
  if (window.__arbAccordionCssReady) return;
  window.__arbAccordionCssReady = true;

  // Sets the open/closed state on an accordion item and, when the toggle is a
  // real disclosure <button> (arb-faq), mirrors it onto aria-expanded.
  // Backwards-compatible with the div-based toggles still used by
  // arbt-retailer-locator / arbt-tool-resource-detail: those toggles carry no
  // aria-expanded attribute, so only the data-accordion-status flips.
  function setItemState(item, active) {
    item.setAttribute('data-accordion-status', active ? 'active' : 'not-active');

    var toggle = item.querySelector('[data-accordion-toggle]');
    if (toggle && toggle.hasAttribute('aria-expanded')) {
      toggle.setAttribute('aria-expanded', active ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-accordion-toggle]');
    if (!toggle) return;

    var accordion = toggle.closest('[data-accordion-css-init]');
    var item = toggle.closest('[data-accordion-status]');
    if (!accordion || !item) return;

    var isActive = item.getAttribute('data-accordion-status') === 'active';
    setItemState(item, !isActive);

    if (!isActive && accordion.getAttribute('data-accordion-close-siblings') === 'true') {
      accordion.querySelectorAll('[data-accordion-status="active"]').forEach(function (sibling) {
        if (sibling !== item) setItemState(sibling, false);
      });
    }
  });
})();
